<script>
import ChartCardWrapper from "@/components/kerdar/components/ChartCardWrapper"
import LineEChart from "@/components/kerdar/components/LineEChart"
import { avandSelectDurationList } from "@/components/kerdar/utils/duration"

import {
  generateHoursJalaliMoment,
  formatJalaliMomentRange,
} from "@/components/kerdar/utils/generalMethods.js"
import kerdarServices from "@/components/kerdar/services/servicesRepository"
import j2Moment from "jalali-moment"

export default {
  name: "AvandTransactionCount",
  components: {
    ChartCardWrapper,
    LineEChart,
  },
  props: {
    duration: {
      type: Object,
      default: () => {},
    },
    kerdarLang: {
      type: Object,
      default: () => {},
    },
    defaultSelectedDuration: {
      type: Object,
      default: () => {
        return {
          name: "ماه جاری",
          value: "current_month",
        }
      },
    },
  },
  data() {
    return {
      noData: false,
      avandTransactionCreditAndDebitData: [],
      avandTransactionCreditAndDebitStatus: false,
      avandTransactionCreditAndDebitFilter: null,
      updateKeyCounter: 0,
      dayHourly: [],
      weekDaily: [],
      monthDaily: [],
      monthWeekly: [],
      avandSelectDurationList,
    }
  },
  computed: {
    avandTransactionSumOfCreditAndDebitXValue() {
      if (
        this.avandTransactionCreditAndDebitFilter &&
        this.avandTransactionCreditAndDebitFilter.timePeriod === "hourly"
      ) {
        let xValue = []
        for (let element of this.avandTransactionCreditAndDebitData) {
          xValue.push(j2Moment(element[0]).format("HH"))
        }
        return xValue
      }

      return this.avandTransactionCreditAndDebitData.map((item) =>
        j2Moment(item[0]).locale("fa").format("D MMMM")
      )
    },
    avandTransactionCreditAndDebitTime() {
      if (
        this.avandTransactionCreditAndDebitFilter.duration === "current_day" &&
        this.avandTransactionCreditAndDebitFilter.timePeriod === "hourly"
      ) {
        let times = []
        generateHoursJalaliMoment(
          times,
          this.avandTransactionCreditAndDebitData
        )
        return times
      } else if (
        this.avandTransactionCreditAndDebitFilter.duration ===
          "current_month" &&
        this.avandTransactionCreditAndDebitFilter.timePeriod === "weekly"
      ) {
        let times = []
        this.avandTransactionCreditAndDebitData.map(([startDate, endDate]) =>
          formatJalaliMomentRange(startDate, endDate, times)
        )
        return times
      }
      return this.avandTransactionCreditAndDebitData.map((item) =>
        j2Moment(item[0]).locale("fa").format("D jMMMM jYYYY")
      )
    },
  },
  watch: {
    currencyName() {
      this.updateKeyCounter++
    },
  },
  methods: {
    clearData() {
      this.avandTransactionCreditAndDebitStatus = false
      this.avandTransactionCreditAndDebitData = []
    },
    changeChartFilter(item) {
      this.avandTransactionCreditAndDebitFilter = item
      this.clearData()
      this.getAvandTransactionCreditAndDebitData(item)
    },
    async getAvandTransactionCreditAndDebitData(item) {
      const response = await kerdarServices(
        this.$http,
        this
      ).avand.httpGetAvandTransactionCreditAndDebit(item)

      this.updateKeyCounter++

      const {
        data: { data },
      } = response
      if (
        data?.length === 1 &&
        data[0].length === 2 &&
        data[0][0] === 0 &&
        data[0][1] === 0
      ) {
        this.noData = true
        return
      }
      this.noData = false
      this.avandTransactionCreditAndDebitData = data

      this.avandTransactionCreditAndDebitStatus = true
    },
    calculateYAxisValue() {
      return this.avandTransactionCreditAndDebitData.map((item) =>
        this.checkCurrency(item.at(-2))
      )
    },
    calculateY2AxisValue() {
      return this.avandTransactionCreditAndDebitData.map((item) =>
        this.checkCurrency(item.at(-1))
      )
    },
    checkCurrency(element) {
      if (this.currencyName === "تومان") {
        return element / 10
      }
      return element
    },
  },
}
</script>

<template>
  <ChartCardWrapper
    title="حجم تراکنش‌های واریز و برداشت هر حساب به تفکیک زمان"
    :show-filter="true"
    :custom-duration="avandSelectDurationList"
    :has-account-filter-select-box="true"
    :selected-custom-duration="defaultSelectedDuration"
    @changeFilter="changeChartFilter($event)"
  >
    <span v-if="noData"> نموداری برای نمایش وجود ندارد </span>
    <LineEChart
      v-else-if="avandTransactionCreditAndDebitStatus"
      :key="updateKeyCounter"
      chart-id="credit-and-debit"
      chart-name="واریز"
      :custom-label="currencyName"
      chart-name-second="برداشت"
      :x-axis-data="avandTransactionSumOfCreditAndDebitXValue"
      :y-axis-data="calculateYAxisValue()"
      :y-axis-data-second="calculateY2AxisValue()"
      :date-time-list="avandTransactionCreditAndDebitTime"
    />
    <div v-else class="skeleton_box2 mmt-10" style="min-height: 276px" />
  </ChartCardWrapper>
</template>

<style scoped></style>
